const Comments = () => import('./components/Comments')

export default [
  {
    name: 'comments.index',
    path: '/comments',
    component: Comments,
    meta: {
      hideNavbar: false,
      requiresAuth: true,
      permission: {
        context: 'comments',
        access: 'read'
      }
    }
  }
]
